
/**
 ==============================================================
 公共模块 API
 ============================================================== */
// 【二次认证发送验证码】
const httpGetTwoFactorAuthSendSecret = (params) => {
  return axios.get('/twoFactorAuthentication/sendSecret', { params });
};

// 【获取二维码】
const httpGetQRCode = () => {
	return axios.get('/twoFactorAuthenticationLoadQr');
};

// 【获取验证码】
const httpGetAccountCaptcha = () => {
  return '/auth/account/captcha?' + Math.floor(Math.random() * 1000);
};

// 【校验用户名及验证码】
const httpGetAccountCheckCaptchaCode = (params) => {
  return axios.get('/account/checkCaptchaCode', { params });
};

// 【邮箱验证码校验】
const httpGetAccountCheckEmailCode = (params) => {
  return axios.get('/account/checkEmailCode', { params });
};

// 【重置密码】
const httpGetAccountUpdatePassword = (params) => {
  return axios.get('/account/updatePassword', { params });
};


// 【获取用户手机号】
const httpGetUserInfoPhone = (data) => {
  return axios.post('/user/getUserPhone', data);
};

// 【发送手机验证码】
const httpGetAuthCode = (tell, params) => {
  return axios.get(`/dynamicAuthCode/sendAuth/${tell}`, { params });
};

// 【校验验证码】
const httpPostValidateVCode = (data) => {
  return axios.post('/dynamicAuthCode/validate', data);
};

// 【登录页-获取用户idp配置】
const httpGetUserIdpConf = (params) => {
	return axios.get('/sso/getUserIdpConf', { params });
};

// 【登录页-sso登录】
const httpPostSsoLogin = (params) => {
	// const formData = new FormData();
	const data = new URLSearchParams();
	Object.entries(params).forEach(([key, value]) => {
		// formData.append(key, value);
		data.append(key, value);
	});
	return axios.post('/sso/sso-login', data, {
		headers: {
			// 'Content-Type': 'multipart/form-data', // 设置请求头
			'Content-Type': 'application/x-www-form-urlencoded'
		},
	});
};
/** ===============END  公共模块 API ================= */

